import React from 'react'

import { useLocation } from 'react-router-dom'
import { makeTraceDetails } from 'common'
import { ErrorHandler } from 'components'

import { NewServiceView } from './NewServiceView'
import { useNewService } from '../hooks/useNewService'

export function NewService() {
  const { state } = useLocation()

  const service = state?.service

  const {
    details,
    subjects,
    upload,
    selectOptions,
    selectedValue,
    textValue,
    textInfo,
    sendSupportButtonLabel,
    isSendButtonDisabled,
    isLoading,
    isEditService,
    title,
    hasScroll,
    ref,
    errorOnFiles,
    isLoadingFiles,
    uploadPercentage,
    isActive,
    onDelete,
    onSelectFiles,
    onSendRequest,
    onUpdateRequest,
    onChangeText,
    onChange,
  } = useNewService({ service })

  if (!isActive) {
    const traceDetails = makeTraceDetails(isActive, {
      details,
      title,
      sendSupportButtonLabel,
      subjects,
      upload,
    })

    return <ErrorHandler traceDetails={traceDetails} componentName={NewService.name} />
  }
  return (
    <NewServiceView
      options={selectOptions}
      select={subjects}
      textArea={details}
      upload={upload}
      selectedValue={selectedValue}
      textValue={textValue}
      textInfo={textInfo}
      sendSupportButtonLabel={sendSupportButtonLabel}
      isSendButtonDisabled={isSendButtonDisabled}
      isLoading={isLoading}
      isEditService={isEditService}
      title={title}
      hasScroll={hasScroll}
      customRef={ref}
      errorOnFiles={errorOnFiles}
      isLoadingFiles={isLoadingFiles}
      uploadPercentage={uploadPercentage}
      onChangeText={onChangeText}
      onChange={onChange}
      onSelectFiles={onSelectFiles}
      onSendRequest={onSendRequest}
      onDelete={onDelete}
      onUpdateRequest={onUpdateRequest}
    />
  )
}
